export const home_i18n = {
    text1: "Wyślij swój pierwszy check-in do podpisu",
    text2: "Wirtualny check-in zbiera dane biometryczne gościa i wiąże je z jego rezerwacją.",
    text3: "Wyślij check-in",
    text4: 'Start',
    text5: "Check-in",
    text6: "Witamy",
    text7: "Konfiguracja check-in",
    text8: "moje konto",
    text9: "Konfiguracja check-in",
    text10: "Wyloguj się",
    text11: "Zdjęcie hotelu",
    text12: "Regulamin hotelu",
    text13: "wiadomości powitalne",
    text14: "Wgraj logo swojego hotelu",
    text15: "Wybierz lub przeciągnij logo",
    text16: "Anuluj",
    text17: "Nazwa hotelu",
    text18: "Zapisz zmiany",
    text19: "Zmień logo",
    text20: "Pobierz",
    text21: "Historia podpisów",
    text22: "Panel kontrolny dokumentów podpisanych przez gości.",
    text23: "Filtr:",
    text24: "Wyłączony",
    text25: "Według daty",
    text26: "Według kraju",
    text27: "Imię",
    text28: "Nazwisko",
    text29: "Narodowość",
    text30: "Data check-in",
    text31: "Zsynchronizowano",
    text32: "Opcje",
    text33: "Brak danych",
    text34: "Wierszy na stronę:",
    text35: "Szukaj",
    text36: "Kraje",
    text37: "Od",
    text38: "Do",
    text39: "COPYRIGHT © 2022 , Wszelkie prawa zastrzeżone WACheckines",
    text40: "Stworzone z",
    text41: "Eksportuj",
    text42: "Zobacz szczegóły",
    text43: "Zobacz podpisany PDF",
    text44: "Usuń",
    text45: "Wybierz opcję",
    //aca
    text46: "Dodaj metodę płatności",
    text47: "Zarejestruj lub zaktualizuj metodę płatności, z której będą pobierane miesięczne opłaty.",
    text48: "Całkowite zadłużenie",
    text49: "Płatność zrealizowana",

    p1: "Trwa okres próbny",
    p2: "Pozostało",
    p3: "dni!",
    p4: "Okres próbny dobiegł końca.",
    p5: "Wykup subskrypcję",
    p6: "Bezpłatny okres próbny dobiegł końca!",

};
